/*
 * QuestionnaireQuestion Messages
 *
 * This contains all the text for the QuestionnaireQuestion component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'components.QuestionnaireQuestion';

export default defineMessages({
  descriptionOpt: {
    id: `${scope}.descriptionOpt`,
    defaultMessage: 'Description (optional)',
  },
  addAnswer: {
    id: `${scope}.addAnswer`,
    defaultMessage: 'Add answer',
  },
  code: {
    id: `${scope}.code`,
    defaultMessage: 'Code (optional)',
  },
});
